export default {
  year: 'yyyy',
  month: 'yyyy-MM',
  quarter: 'yyyy-MM-dd',
  date: 'yyyy-MM-dd',
  time: 'HH:mm:ss',
  datetime: 'yyyy-MM-dd HH:mm:ss',
  week: 'yyyy-MM-dd'
}
